<template>
  <div>
    <PopperCard v-if="items.length" placement="top" :style-class="{ 'candidate-popper': true }">
      <WdsLabel primary subtle class="tw-cursor-default">
        {{ items.length }}
      </WdsLabel>
      <template #title-wrap>
        <div class="tw-px-4 tw-pt-3 tw-text-gray-600 tw-text-sm tw-flex tw-items-center">
          <WdsIcon :name="titleIcon" class="tw-mr-2" style="display: inline" :size="16" />
          <span>{{ title }}</span>
        </div>
      </template>
      <template #content-wrap>
        <div class="tw-pb-3 tw-px-4 tw-text-sm">
          <a
            v-for="{ url, text } in items"
            :key="url"
            class="tw-pt-2 tw-block"
            :href="url"
            target="_blank"
          >
            {{ text ? text : url }}
          </a>
        </div>
      </template>
    </PopperCard>
  </div>
</template>

<script setup>
import { WdsLabel, WdsIcon } from '@worksome/wds-components'
import PopperCard from '@/components/PopperCard.vue'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  title: {
    type: String,
    required: true,
  },
  titleIcon: {
    type: String,
    required: true,
  },
})
</script>

<style lang="scss">
.candidate-popper {
  min-width: auto !important;
  &::before {
    background-color: transparent !important;
  }
}
</style>
